export default __webpack_public_path__ + "static/media/clock-gray.bbb17924.svg";